<template>
  <router-view />
</template>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: "Segoe UI", "Inter", system-ui, -apple-system, sans-serif;
  background: #F4F6F8;
  color: #1C2128;
  -webkit-font-smoothing: antialiased;
}
</style>
